<template>
	<el-dialog class="addDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				{{data.id ? '编辑' : '新增'}}收货地址
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
				<el-form-item label="地址信息：" prop="city">
					<el-cascader v-model="ruleForm.city" separator=""
						:props="{ label: 'name', value: 'name', children: 'children' }" :options="citys"
						@change="handleChange"></el-cascader>
				</el-form-item>
				<el-form-item label="详细地址：" prop="address">
					<el-input v-model="ruleForm.address" placeholder="请输入详细地址" />
				</el-form-item>
				<el-form-item label="收货人姓名：" prop="name">
					<el-input v-model="ruleForm.name" placeholder="请输入收货人姓名" />
				</el-form-item>
				<el-form-item label="手机号码：" prop="phone">
					<el-input v-model="ruleForm.phone" placeholder="请输入手机号码" />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium" @click="submitForm('ruleForm')">提交</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import citys from "@/assets/js/citys.js";
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => {},
			}
		},
		watch: {
			data: {
				handler(newValue) {
					this.ruleForm = {
						id: newValue.id,
						address: newValue.address,
						phone: newValue.phone,
						name: newValue.name,
						city: []
					}
					if (newValue.sheng && newValue.shi && newValue.qu) {
						this.ruleForm['city'].push(newValue.sheng)
						this.ruleForm['city'].push(newValue.shi)
						this.ruleForm['city'].push(newValue.qu)
					}
				},
				deep: true
			}
		},
		data() {
			return {
				ruleForm: {
					city: [],
					address: '',
					phone: '',
					name: ''
				},
				rules: {
					city: [{
						required: true,
						message: '请选择省/市/区',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入收货人姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}],
				},
				citys: citys,
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			handleChange(event) {
				console.log(event)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/user_address_save', {
							...this.ruleForm,
							sheng: this.ruleForm.city[0],
							shi: this.ruleForm.city[1],
							qu: this.ruleForm.city[2],
						}).then(res => {
							if (res.code == 1) {
								this.$emit('update')
								this.handleClose()
							}
							this.$message.success(res.msg)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.addDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
<style>
	.el-cascader-node {
		margin-bottom: 0 !important;
	}
</style>